var _style, _g, _circle, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMotoclubNewLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 725 170",
    style: {
      enableBackground: "new 0 0 725 170"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270.8,108.8l-0.1-36l-15.6,15.4l-15.7-15.3l0.1,36h-10.9L228.4,50h3.7L255,72.3l22.7-22.4h3.8l0.2,58.9     H270.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M359.3,79c0,16.8-12.6,30.5-28.2,30.6c-15.6,0-28.3-13.6-28.4-30.4s12.6-30.5,28.2-30.6     C346.5,48.6,359.2,62.2,359.3,79z M313.9,79.2c0,10.2,7.7,18.4,17.1,18.3s17.1-8.3,17-18.4c0-10.2-7.7-18.4-17.1-18.3     S313.9,69,313.9,79.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M416.4,49.5v11.8h-15.1l0.1,47.1h-10.9l-0.1-47.1h-15.2V49.5L416.4,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M487.5,78.6c0,16.8-12.6,30.5-28.2,30.6c-15.6,0-28.3-13.6-28.4-30.4s12.6-30.5,28.2-30.6     C474.7,48.2,487.5,61.9,487.5,78.6z M442.2,78.8c0,10.2,7.7,18.4,17.1,18.3s17.1-8.3,17-18.4c0-10.2-7.7-18.4-17.1-18.3     S442.1,68.6,442.2,78.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M544.2,63.4c-10.6-7.4-26.6-0.4-26.5,15.4c0,16.5,17,23.1,27.3,14.7l7,8.6c-4.9,4.4-11.2,7.1-18.1,7.1     c-15.6,0-28.3-13.6-28.4-30.4s12.6-30.5,28.2-30.6c6.5,0,12.6,2.4,17.5,6.4L544.2,63.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M584.7,96.1L605,96v11.7l-31.3,0.1L573.6,49h10.9L584.7,96.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M668,85.8c0,12.6-9.4,22.8-21.1,22.8c-11.7,0-21.2-10.1-21.3-22.6l-0.1-37.2h10.9l0.1,37.1     c0,2.9,1.1,5.7,3.1,7.8c2,2.1,4.5,3.2,7.3,3.2c2.7,0,5.2-1.1,7.2-3.2c1.9-2.1,2.9-4.8,3-7.7H657l-0.1-37.2h10.9L668,85.8     L668,85.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M702.6,48.7c8.8,0,16,7.7,16,17.2c0,3.6-1,6.9-2.8,9.7c4,3.3,6.5,8.4,6.5,14.1c0,9.9-7.4,17.8-16.5,17.8     l-18,0.1l-0.2-58.8L702.6,48.7z M702.2,72c3,0,6.3-2.7,6.3-6.8c0-4.1-3.3-6.6-6.3-6.6h-4.8V72H702.2z M705.8,97.5     c3.7,0,6.7-3.1,6.7-7.1c0-3.9-3.1-7.1-6.7-7.1h-8v14.2H705.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M306,167.1v-18.6h4.6c2.8,0,5.1,0.8,6.7,2.5c1.6,1.6,2.5,3.9,2.5,6.8c0,2.9-0.8,5.2-2.4,6.9     s-3.9,2.4-6.7,2.4L306,167.1L306,167.1z M309.5,163.8h1.2c1.7,0,3-0.5,4-1.6c1-1,1.4-2.5,1.4-4.5c0-1.9-0.5-3.4-1.5-4.5     c-1-1-2.3-1.6-3.9-1.6h-1.2V163.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327.1,167.1v-18.6h3.5v18.6H327.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.8,148.1c1.6,0,3,0.3,4.2,1s2,1.4,2.6,2.1l-2.2,2.4c-1.2-1.4-2.6-2-4.5-2c-1.7,0-3,0.6-4,1.8     s-1.5,2.6-1.5,4.4c0,1.9,0.5,3.3,1.5,4.5c1,1.1,2.3,1.7,3.9,1.7c1.1,0,1.9-0.2,2.6-0.5s1.2-0.7,1.5-1v-2.3h-3.3V157h6.5v7.4     c-1.1,1-2.2,1.7-3.3,2.3c-1.2,0.5-2.6,0.8-4.2,0.8c-2.5,0-4.6-0.9-6.4-2.7s-2.6-4.1-2.6-7c0-2.7,0.8-5,2.5-6.9     C342.1,149.1,344.2,148.1,346.8,148.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M362.2,167.1v-18.6h3.5v18.6H362.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M376.8,167.1v-15.2h-4v-3.4h11.5v3.4h-4v15.2H376.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M399.3,162.3h-5.9l-1.5,4.8h-3.5l6.1-18.6h3.7l6.1,18.6h-3.5L399.3,162.3z M398.4,159.2l-2-6.7l-2,6.7H398.4     z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.1,167.1v-18.6h3.5v15.2h5.6v3.4L411.1,167.1L411.1,167.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M446.4,167.4c-2.7,0-4.8-0.9-6.5-2.7s-2.5-4.1-2.5-6.9c0-2.7,0.9-5,2.6-6.9s3.9-2.8,6.5-2.8     c2,0,3.7,0.6,5.1,1.7l-1,3.3c-1.3-1-2.7-1.5-4.1-1.5c-1.6,0-2.8,0.6-3.9,1.8c-1,1.2-1.5,2.6-1.5,4.4c0,1.8,0.5,3.3,1.5,4.4     c1,1.2,2.3,1.7,3.9,1.7c1.5,0,2.9-0.5,4.3-1.5l1,3.3C450.3,166.8,448.5,167.4,446.4,167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M473.5,164.7c-1.7,1.8-3.8,2.8-6.5,2.8c-2.6,0-4.8-0.9-6.5-2.8c-1.7-1.8-2.5-4.1-2.5-6.9     c0-2.7,0.8-5,2.5-6.9c1.7-1.8,3.8-2.8,6.5-2.8c2.6,0,4.8,0.9,6.5,2.8s2.5,4.1,2.5,6.9C476.1,160.6,475.2,162.8,473.5,164.7z      M470.9,153.4c-1-1.2-2.3-1.8-3.8-1.8s-2.8,0.6-3.8,1.8s-1.5,2.6-1.5,4.4c0,1.8,0.5,3.3,1.5,4.4c1,1.2,2.3,1.7,3.8,1.7     s2.8-0.6,3.8-1.7c1-1.2,1.5-2.6,1.5-4.4S471.9,154.6,470.9,153.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M483.4,167.1v-18.6h3.5v15.2h5.6v3.4L483.4,167.1L483.4,167.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M499.5,167.1v-18.6h3.5v15.2h5.6v3.4L499.5,167.1L499.5,167.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M515.7,167.1v-18.6h8.9v3.4h-5.4v4.1h4.6v3.3h-4.6v4.4h5.6v3.3h-9.1V167.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M540.6,167.4c-2.7,0-4.8-0.9-6.5-2.7s-2.5-4.1-2.5-6.9c0-2.7,0.9-5,2.6-6.9s3.9-2.8,6.5-2.8     c2,0,3.7,0.6,5.1,1.7l-1,3.3c-1.3-1-2.7-1.5-4.1-1.5c-1.6,0-2.8,0.6-3.9,1.8c-1,1.2-1.5,2.6-1.5,4.4c0,1.8,0.5,3.3,1.5,4.4     c1,1.2,2.3,1.7,3.9,1.7c1.5,0,2.9-0.5,4.3-1.5l1,3.3C544.4,166.8,542.6,167.4,540.6,167.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M556.1,167.1v-15.2h-4v-3.4h11.5v3.4h-4v15.2H556.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M570.7,167.1v-18.6h3.5v18.6H570.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M582.4,167.1v-18.6h5.5c1.7,0,3.1,0.4,4.1,1.3c1,0.9,1.5,2.1,1.5,3.6c0,0.8-0.2,1.6-0.6,2.4     c-0.4,0.7-0.9,1.3-1.5,1.6c0.8,0.4,1.5,0.9,1.9,1.7c0.5,0.7,0.7,1.6,0.7,2.5c0,1.7-0.6,3.1-1.7,4s-2.5,1.4-4.2,1.4h-5.7V167.1z      M585.9,156h2c0.6,0,1.1-0.2,1.5-0.6c0.4-0.4,0.6-0.9,0.6-1.6s-0.2-1.1-0.6-1.5c-0.4-0.4-0.9-0.6-1.6-0.6h-1.9V156z M585.9,163.9     h2.1c0.7,0,1.3-0.2,1.8-0.7c0.5-0.4,0.7-1,0.7-1.8c0-0.7-0.2-1.3-0.7-1.8c-0.5-0.4-1.1-0.6-1.8-0.6h-2.1V163.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M601.5,167.1v-18.6h3.5v15.2h5.6v3.4L601.5,167.1L601.5,167.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M617.6,167.1v-18.6h8.9v3.4h-5.4v4.1h4.6v3.3h-4.6v4.4h5.6v3.3h-9.1V167.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M639.2,148.1c0.8,0,1.6,0.1,2.2,0.4c0.7,0.3,1.2,0.7,1.6,1.1c0.4,0.5,0.7,0.9,0.9,1.3     c0.2,0.4,0.4,0.8,0.5,1.2l-2.9,1.4c-0.6-1.3-1.4-2-2.5-2c-0.6,0-1,0.2-1.4,0.5s-0.5,0.8-0.5,1.3s0.3,1,0.8,1.5     c0.5,0.4,1.1,0.8,1.9,1.2c0.7,0.3,1.5,0.7,2.2,1.2c0.7,0.4,1.4,1,1.9,1.8s0.8,1.7,0.8,2.8c0,1.7-0.5,3-1.6,4.1     c-1,1.1-2.4,1.6-4.2,1.6c-0.9,0-1.7-0.1-2.4-0.4s-1.3-0.7-1.7-1.2s-0.8-0.9-1-1.4c-0.3-0.4-0.5-0.9-0.6-1.3l2.9-1.5     c0.6,1.6,1.6,2.4,3,2.4c0.6,0,1.1-0.2,1.5-0.5s0.5-0.8,0.5-1.4c0-0.6-0.3-1.1-0.8-1.5s-1.1-0.8-1.9-1.2s-1.5-0.8-2.2-1.2     s-1.4-1.1-1.9-1.9s-0.8-1.7-0.8-2.8c0-1.6,0.5-2.9,1.5-3.8C636.3,148.6,637.6,148.1,639.2,148.1z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.6,
    y1: 87,
    x2: 167,
    y2: 87,
    gradientTransform: "matrix(1 0 0 -1 0 172)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4976,
    style: {
      stopColor: "#793EFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB27FA"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 84.3,
    cy: 85,
    r: 82.7
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76,87L33.1,64.4c-1-0.5-2.2,0.2-2.2,1.3v14.5c0,0.6,0.3,1.1,0.8,1.3l42.9,22.6c1,0.5,2.2-0.2,2.2-1.3V88.3     C76.8,87.7,76.5,87.2,76,87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M87.3,118.8L44.4,96.2c-1-0.5-2.2,0.2-2.2,1.3V112c0,0.6,0.3,1.1,0.8,1.3L85.9,136c1,0.5,2.2-0.2,2.2-1.3     v-14.5C88.1,119.6,87.8,119,87.3,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M116.5,72.8v47.6c0,1.3,1.3,2.1,2.5,1.5l12.6-6.3c0.6-0.3,0.9-0.9,0.9-1.5V45.8c0-1.3-1.4-2.1-2.5-1.5     L88.1,66.6c-0.5,0.3-1.1,0.3-1.6,0L44.7,44.4c-1.1-0.6-2.5,0.2-2.5,1.5V60c0,0.6,0.4,1.2,0.9,1.5l43.7,23.2     c0.5,0.3,1.1,0.3,1.6,0L114,71.3C115.1,70.7,116.5,71.5,116.5,72.8z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotoclubNewLogo);
export default __webpack_public_path__ + "static/media/motoclub-new-logo.91b20b92.svg";
export { ForwardRef as ReactComponent };